import { fetchFromAPI } from 'utils/api';

export function getExternalSources(params) {
  return fetchFromAPI('/admin/external_sources', { params });
}
